// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, CheckCircle, Loader2, X } from 'lucide-react';
import { getToasts, removeToast, subscribeToasts } from '../lib/toastStore';
import './ToastNotifications.css';

export default function ToastNotifications() {
  const [toasts, setToasts] = useState(getToasts);

  useEffect(() => subscribeToasts(setToasts), []);

  if (!toasts.length) return null;

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast--${toast.type}`}>
          <span className="toast-icon">
            {toast.type === 'generating' ? <Loader2 size={15} className="toast-spinner" /> : null}
            {toast.type === 'success' ? <CheckCircle size={15} /> : null}
            {toast.type === 'error' ? <AlertCircle size={15} /> : null}
            {toast.type === 'info' ? <AlertCircle size={15} /> : null}
          </span>
          <span className="toast-message">{toast.message}</span>
          {toast.link ? (
            <Link to={toast.link} className="toast-link" onClick={() => removeToast(toast.id)}>
              {toast.linkLabel || 'View'}
            </Link>
          ) : null}
          <button type="button" className="toast-close" onClick={() => removeToast(toast.id)} aria-label="Dismiss">
            <X size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
